import React, { useEffect, useState } from 'react';
import './App.css';

const LinkButton = ({ href, icon, label, color, hoverColor }) => (
  <a 
    href={href} 
    target="_blank" 
    rel="noopener noreferrer" 
    className="link-button"
    style={{
      '--button-color': color,
      '--hover-color': hoverColor
    }}
  >
    <i className={icon}></i>
    <span>{label}</span>
  </a>
);

// const linksData = [
//   {
//     href: "https://facebook.com/f1rstmotors",
//     icon: "fab fa-facebook-f",
//     label: "Facebook",
//     color: "#1877F2",
//     hoverColor: "#166FE5"
//   },
//   {
//     href: "https://youtube.com/@f1rstmotors",
//     icon: "fab fa-youtube",
//     label: "YouTube",
//     color: "#FF0000",
//     hoverColor: "#E60000"
//   },
//   {
//     href: "https://instagram.com/f1rstmotors",
//     icon: "fab fa-instagram",
//     label: "Instagram",
//     color: "#E4405F",
//     hoverColor: "#D73653"
//   },
//   {
//     href: "https://f1rstmotors.com",
//     icon: "fas fa-globe",
//     label: "Website",
//     color: "#6366F1",
//     hoverColor: "#5856EB"
//   },
//   {
//     href: "https://www.linkedin.com/company/f1rst-motors/",
//     icon: "fab fa-linkedin-in",
//     label: "LinkedIn",
//     color: "#0A66C2",
//     hoverColor: "#095BB0"
//   },
//   {
//     href: "https://x.com/f1rstmotors",
//     icon: "fab fa-twitter",
//     label: "Twitter",
//     color: "#1DA1F2",
//     hoverColor: "#1A94DA"
//   }
// ]

function App() {
  const [links, setLinks] = useState([]);
  useEffect(() => {
    const getLinks = async () => {
      const res = await fetch(`https://f1rstmotors.com/api/v1/en/settings/links`);
      const data = await res.json();
      setLinks(data.data.linksObjs);
    }
    getLinks();
  }, []) ;

  return (
    <div className="app">
      <div className="container">
        <div className="profile-section">
          <div className="profile-image">
            <img 
              src="/logo.png" 
              alt="F1rst Motors Logo" 
            />
          </div>
          <p className="bio">Discover the world of F1rst Motors! Follow us on all our social media channels.</p>
        </div>

        <div className="links-section">
          {links.map((link, index) => (
            <LinkButton
              key={index}
              href={link.href}
              icon={link.icon}
              label={link.label}
              color={link.color}
              hoverColor={link.hoverColor}
            />
          ))}
        </div>

        <div className="footer">
          <p>© {new Date().getFullYear()} f1rstmotors. All rights reserved.</p>
        </div>
      </div>
    </div>
  );
}

export default App;